import { eCommerceTrackEvent, insertTrackEvent } from './common.js';

const trackSportsbookEvent = (category, action, label = '', value = '') => {
	if (!category || !action) {
		throw new Error('To track sportsbook event provide at least category and action');
	}
	insertTrackEvent({
		category,
		action,
		label,
		value
	});
};

// If you change something, remember to update types in index.d.ts

const OPEN_SEARCH_CATEGORY = 'Sportsbook - Search Click';
export const trackSportsbookOpenSearch = () => {
	trackSportsbookEvent(OPEN_SEARCH_CATEGORY, 'Search Start');
};

const SEARCH_RESULT_CATEGORY = 'Sportsbook - Search Result';
export const trackSportsbookSearchResult = (query, result) => {
	trackSportsbookEvent(SEARCH_RESULT_CATEGORY, result, query);
};

const MY_BETS_SHARE_BET_CATEGORY = 'Sportsbook - My Bets - Share Bet';
export const trackSportsbookOpenMyBetsShareBet = () => {
	trackSportsbookEvent(MY_BETS_SHARE_BET_CATEGORY, 'Open');
};
export const trackSportsbookUseMyBetsShareBet = () => {
	trackSportsbookEvent(MY_BETS_SHARE_BET_CATEGORY, 'Use');
};

const OPEN_DATE_CALENDAR_CATEGORY = 'Sportsbook - Sport Date Calendar';
export const trackSportsbookOpenSportDateCalendar = (sportId, sportName) => {
	const label = `Sport Id: ${sportId}, Sport Name: ${sportName}`;
	trackSportsbookEvent(OPEN_DATE_CALENDAR_CATEGORY, 'Open', label);
};

// Track my bets calendar
const MY_BETS_CALENDAR_CATEGORY = 'Sportsbook - My Bets Calendar';
export const trackSportsbookMyBetsCalendar = () => {
	trackSportsbookEvent(MY_BETS_CALENDAR_CATEGORY, 'Click');
};

// Track Betslip Events

const ADD_TO_BETSLIP_CATEGORY = 'Sportsbook - Add to Betslip';
export const trackSportsbookAddToBetslip = (eventId, marketId, selectionId, odds, tag) => {
	const label = tag
		? `Event: ${eventId}, Market: ${marketId}, Selection: ${selectionId}, Odds: ${odds}, Source: ${tag}`
		: `Event: ${eventId}, Market: ${marketId}, Selection: ${selectionId}, Odds: ${odds}`;
	trackSportsbookEvent(ADD_TO_BETSLIP_CATEGORY, 'Successful', label);
};

const PLACE_BET_CATEGORY = 'Sportsbook - Place Bet';
export const trackSportsbookPlaceBetAttempt = (numberOfBets, betType, totalStake) => {
	const label = `Bet Count: ${numberOfBets} - Bet Type: ${betType}`;
	trackSportsbookEvent(PLACE_BET_CATEGORY, 'Attempt', label, totalStake);
};
export const trackSportsbookPlaceBetSuccessful = (betType, stake, tags) => {
	const label = tags ? `Bet Type: ${betType} - Source: ${tags}` : `Bet Type: ${betType}`;
	trackSportsbookEvent(PLACE_BET_CATEGORY, 'Successful', label, stake);
};
export const trackSportsbookPlaceBetFailed = (betType, errorType, stake, tags) => {
	const label = tags
		? `Bet Type: ${betType} - Error Type: ${errorType} - Source: ${tags}`
		: `Bet Type: ${betType} - Error Type: ${errorType}`;
	trackSportsbookEvent(PLACE_BET_CATEGORY, 'Failed', label, stake);
};

const NEW_OFFER_CATEGORY = 'Sportsbook - New Offer';
export const trackSportsbookNewOfferShown = () => {
	trackSportsbookEvent(NEW_OFFER_CATEGORY, 'Shown');
};
export const trackSportsbookNewOfferAccepted = () => {
	trackSportsbookEvent(NEW_OFFER_CATEGORY, 'Accepted');
};
export const trackSportsbookNewOfferRejected = () => {
	trackSportsbookEvent(NEW_OFFER_CATEGORY, 'Rejected');
};

const CHECK_BET_CATEGORY = 'Sportsbook - Check Bet';
export const trackSportsbookCheckBetFailed = (betType, errorType) => {
	const label = `Bet Type: ${betType} - Error Type: ${errorType}`;
	trackSportsbookEvent(CHECK_BET_CATEGORY, 'Failed', label);
};

const BETSLIP_SHARE_BET_CATEGORY = 'Sportsbook - Betslip - Share Bet';
export const trackSportsbookOpenBetslipShareBet = () => {
	trackSportsbookEvent(BETSLIP_SHARE_BET_CATEGORY, 'Open');
};
export const trackSportsbookUseBetslipShareBet = () => {
	trackSportsbookEvent(BETSLIP_SHARE_BET_CATEGORY, 'Use');
};

// Track betslip custom keyboard
const BETSLIP_CUSTOM_KEYBOARD = 'Sportsbook - Betslip - Custom Keyboard';
export const trackSportsbookBetslipCustomKeyboard = (betType, key, currency) => {
	const label = `Bet Type: ${betType} - Keyboard Key: ${key} - Currency: ${currency}`;
	trackSportsbookEvent(BETSLIP_CUSTOM_KEYBOARD, 'Click', label);
};

const MENU_LEAGUE_CATEGORY = 'Sportsbook_Leagues_Menu';
export const trackSportsbookOpenPopularLeague = (leagueId, leagueName) => {
	const label = `League Id: ${leagueId}, League Name: ${leagueName}`;
	trackSportsbookEvent(MENU_LEAGUE_CATEGORY, 'Click', label);
};

const MENU_BROWSE_LEAGUE_CATEGORY = 'Sportsbook_Browse_Leagues_Menu';
export const trackSportsbookOpenBrowsePopularLeague = (leagueId, leagueName) => {
	const label = `League Id: ${leagueId}, League Name: ${leagueName}`;
	trackSportsbookEvent(MENU_BROWSE_LEAGUE_CATEGORY, 'Click', label);
};

const MENU_BROWSE_SPORT_CATEGORY = 'Sportsbook_Browse_Sports_Menu';
export const trackSportsbookOpenBrowsePopularSport = (sportId, sportName) => {
	const label = `Sport Id: ${sportId}, Sport Name: ${sportName}`;
	trackSportsbookEvent(MENU_BROWSE_SPORT_CATEGORY, 'Click', label);
};

const TOP_NAV_PILLS_CATEGORY = 'Sportsbook_Nav_Pill';
export const trackSportsbookUseTopNavPills = navigationLink => {
	trackSportsbookEvent(TOP_NAV_PILLS_CATEGORY, 'Click', navigationLink);
};

const SEARCH_RESULT_ITEM_CATEGORY = 'Sportsbook_Search_Result';
export const trackSportsbookOpenSearchItem = (searchQuery, id, leagueId, sportId) => {
	const label = `${searchQuery},Event:${id},League:${leagueId},Sport:${sportId}`;
	trackSportsbookEvent(SEARCH_RESULT_ITEM_CATEGORY, 'Click', label);
};

export const trackSportsbookSearchItemResult = (searchQuery, id, index, leagueId, sportId) => {
	const label = `${searchQuery},Event:${id},League:${leagueId},Sport:${sportId}`;
	const action = `List_Item_${index + 1}`;
	trackSportsbookEvent(SEARCH_RESULT_CATEGORY, action, label);
};

const OPEN_DROPDOWN_CATEGORY = 'Sportsbook_Event';
export const trackSportsbookClickDropDownInEvent = (isLiveCategory, eventId) => {
	const label = `${isLiveCategory ? 'live' : 'upcoming'} - ${eventId}`;
	const action = `Open_Dropdown`;
	trackSportsbookEvent(OPEN_DROPDOWN_CATEGORY, action, label);
};

export const trackSportsbookClickItemDropDownInEvent = (isLiveCategory, fromEventId, clickedEventId) => {
	const label = `${isLiveCategory ? 'live' : 'upcoming'} - ${fromEventId} - ${clickedEventId}`;
	const action = `Click_Dropdown_Item`;
	trackSportsbookEvent(OPEN_DROPDOWN_CATEGORY, action, label);
};

const SUB_ROUTE_IN_EVENT = 'Sportsbook - Event Sub Route';
export const trackSportsbookClickSubRouteInEvent = (subRoute, sportId) => {
	const label = `sub_route: ${subRoute}, sport_id: ${sportId}`;
	const action = `Click`;
	trackSportsbookEvent(SUB_ROUTE_IN_EVENT, action, label);
};

const CASHOUT_EVENT = 'Sportsbook - Cashout';
export const trackSportsbookCashOut = (betId, sportsId, leagueName) => {
	const label = `bet_id: ${betId}, sport_id: ${sportsId}, league: ${leagueName}`;
	const action = `Click - Start`;
	trackSportsbookEvent(CASHOUT_EVENT, action, label);
};

export const trackSportsbookCashOutSuccessful = (betId, sportsId, leagueName) => {
	const label = `bet_id: ${betId}, sport_id: ${sportsId}, league: ${leagueName}`;
	const action = `Successful`;
	trackSportsbookEvent(CASHOUT_EVENT, action, label);
};

export const trackSportsbookCashOutFailed = (betId, sportsId, leagueName) => {
	const label = `bet_id: ${betId}, sport_id: ${sportsId}, league: ${leagueName} error: Failed`;
	const action = `Failed`;
	trackSportsbookEvent(CASHOUT_EVENT, action, label);
};

// Track Promotions Events
export const trackSportsbookPromotionCarouselImpression = (promotions, carouselName) => {
	if (promotions) {
		eCommerceTrackEvent({
			event: 'EECpromotionImpression',
			eComObj: {
				promoView: {
					promotions: promotions.map((promotion, index) => {
						const {
							id,
							type = '',
							source = '',
							sportId = '',
							marketIds = [],
							selectionIds = []
						} = promotion;
						return {
							id,
							name: `Type: ${type}, Source: ${source}, carousel_name: ${carouselName}`,
							creative: `Sport: ${sportId}; Markets: ${marketIds.join(
								','
							)}; Selections: ${selectionIds.join(',')}`,
							position: index + 1
						};
					})
				}
			}
		});
	}
};
export const trackSportsbookPromotionCarouselClick = (promotion, carouselName, index) => {
	const { id, type = '', source = '', sportId = '', marketIds = [], selectionIds = [] } = promotion;

	eCommerceTrackEvent({
		event: 'EECpromotionClick',
		eComObj: {
			promoClick: {
				promotions: [
					{
						id,
						name: `Type: ${type}, Source: ${source}, carousel_name: ${carouselName}`,
						creative: `Sport: ${sportId}; Markets: ${marketIds.join(',')}; Selections: ${selectionIds.join(
							','
						)}`,
						position: index + 1
					}
				]
			}
		}
	});
};

// Track Websocket connection
const SB_API_WEBSOCKET_CATEGORY = 'Sportsbook - SB API Websocket';
export const trackSportsbookSBApiWebSocketConnectionLostInformNotification = () => {
	trackSportsbookEvent(SB_API_WEBSOCKET_CATEGORY, 'Notification', 'Connection Lost', 'Inform');
};

export const trackSportsbookSBApiWebSocketConnectionLostInformAndReloadNotification = () => {
	trackSportsbookEvent(SB_API_WEBSOCKET_CATEGORY, 'Notification', 'Connection Lost', 'Inform and Reload');
};

// Track game card actions
const GAME_CARD_CATEGORY = 'Sportsbook - Game Card';
export const trackSportsbookNavigationToEventPageFromGameCard = (eventId, marketId, isLive) => {
	trackSportsbookEvent(
		GAME_CARD_CATEGORY,
		'Navigation to event',
		`Event: ${eventId}, Market: ${marketId}, Live: ${isLive}`
	);
};

// Track quick Links based on type
const QUICK_LINKS = 'Sportsbook_Quick_Links';
export const trackSportsbookOpenQuickLinkSport = (order, quickLinkLabel, linkId, sportId, sportName) => {
	const label = `Sport Id: ${sportId}, Sport Name: ${sportName}, Position: ${order}, Link Id: ${linkId}, Label: ${quickLinkLabel}`;
	trackSportsbookEvent(QUICK_LINKS, 'Click', label);
};

export const trackSportsbookOpenQuickLinkLeague = (order, quickLinkLabel, linkId, leagueId, leagueName) => {
	const label = `League Id: ${leagueId}, League Name: ${leagueName}, Position: ${order}, Link Id: ${linkId}, Label: ${quickLinkLabel}`;
	trackSportsbookEvent(QUICK_LINKS, 'Click', label);
};

export const trackSportsbookOpenQuickLinkCustom = (order, quickLinkLabel, linkId, url) => {
	const label = `Position: ${order}, Link Id: ${linkId}, Label: ${quickLinkLabel}, URL: ${url}`;
	trackSportsbookEvent(QUICK_LINKS, 'Click', label);
};
